module.exports = __webpack_public_path__ + "img/result.824039e5.png";